var config = document.getElementById('cart-config');
function getCartConfig() { 
  if (!config) return false;
  config = JSON.parse(config.innerHTML || '{}');
 }

 getCartConfig();

// Card watches
class CardProduct extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', (e) => {
      this.onVariantChange(e);
    });

    this.productForm = this.querySelector(
      `#quick-add-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );

    this.buttonSubmit = this.querySelector('.quick-add__submit');
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();
    console.log(this.currentVariant);
    if (!this.currentVariant) {
      // 
    } else {
      this.updateVariantInput();
      this.updateProductInfo();
      if (e.target.dataset.inputSubmit) {
        setTimeout(() => {
          this.submitForm();
        }, 300);
      }
    }
  }

  submitForm() {
    this.buttonSubmit.click();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options_input = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    this.options_select = Array.from(this.querySelectorAll('select'), (select) => select.value);
    this.options = this.options_input.concat(this.options_select);
  }

  updateProductInfo() {
    const media = this.querySelector('.js-card-image');
    const price = this.querySelector('.js-card-image');

    if (this.currentVariant.featured_image && this.currentVariant.featured_image.src) {
      media.src = this.currentVariant.featured_image.src;
    }
    
    if (this.currentVariant.compare_at_price && this.currentVariant.price != this.currentVariant.compare_at_price) {
      const priceContainer = this.querySelector('.card__content .price');
      const price = this.formatMoney(this.currentVariant.price, config.money_format);
      const priceCopare = this.formatMoney(this.currentVariant.compare_at_price, config.money_format)
      const priceRegular = this.querySelector('.price__sale .price-item--regular');
      const priceSale = this.querySelector('.price__sale .price-item--sale');
      priceContainer.classList.add('price--on-sale')
      if (priceRegular && priceSale) {
        priceRegular.innerHTML = priceCopare;
        priceSale.innerHTML = price;
      }
      
    }
    else {
      const priceContainer = this.querySelector('.card__content .price');
      const price = this.formatMoney(this.currentVariant.price, config.money_format);
      const priceRegular = this.querySelector('.price__regular .price-item--regular');
      if (priceContainer.classList.contains('price--on-sale')) {
        priceContainer.classList.remove('price--on-sale');
      }
      if (priceRegular) {
        priceRegular.innerHTML = price;
      }
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.removeAttribute('disabled');
      } else {
        input.setAttribute('disabled', 'disabled');
        if (input.tagName == "OPTION") {
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        }
      }
    });
  }

  updateVariantInput() {
    const input = this.productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  formatMoney(cents, format) {
    const moneyFormat = '${{amount}}';
  
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
  
    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ',',
      decimal = '.'
    ) {
      if (isNaN(number) || number == null) {
        return 0;
      }
  
      number = (number / 100.0).toFixed(precision);
  
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';
  
      return dollarsAmount + centsAmount;
    }
  
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  }
}

customElements.define('card-product', CardProduct);

// collapsible mobile footer
var headers = document.querySelectorAll('.footer-block--summary');

for(var i = 0; i < headers.length; i++) {
	headers[i].addEventListener('click', openCurrAccordion);
}

function openCurrAccordion(e) {
	for(var i = 0; i < headers.length; i++) {
		var parent = headers[i].parentElement;
		var article = parent.querySelector(".footer-collapsible--content");

		if (this === headers[i] && !parent.classList.contains('open')) {
			parent.classList.add('open');
		}
		else {
			parent.classList.remove('open');
		}
	}
}



